(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('.product-gallery').forEach(gallery => {
      if (gallery.dataset.galleryBound) return;
      const slides = [...gallery.querySelectorAll('.gallery-item')];
      // Keep the native scrollable media experience when videos/models are present.
      if (slides.length < 2 || slides.some(slide => !slide.querySelector('img'))) return;
      gallery.dataset.galleryBound = 'true';
      gallery.classList.add('product-gallery--selectable');
      gallery.removeAttribute('tabindex');
      gallery.removeAttribute('aria-roledescription');
      const controls = document.createElement('div');
      controls.className = 'gallery-controls';
      controls.setAttribute('role', 'group');
      controls.setAttribute('aria-label', 'Choose a product image');
      slides.forEach((slide, index) => {
        slide.hidden = index !== 0;
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `View image ${index + 1} of ${slides.length}`);
        button.setAttribute('aria-pressed', String(index === 0));
        const thumbnail = slide.querySelector('img').cloneNode();
        thumbnail.alt = ''; thumbnail.removeAttribute('srcset'); thumbnail.removeAttribute('sizes');
        thumbnail.removeAttribute('fetchpriority'); thumbnail.width = 64; thumbnail.height = 64;
        // Thumbnail pixels are independent of the full-size gallery image.
        const thumbnailUrl = new URL(thumbnail.src, document.baseURI);
        if (thumbnailUrl.pathname.startsWith('/cdn/shop/') ||
            (thumbnailUrl.hostname === 'cdn.shopify.com' && thumbnailUrl.pathname.startsWith('/s/files/'))) {
          const thumbnailSource = width => {
            const url = new URL(thumbnailUrl);
            url.searchParams.set('width', String(width));
            return url.href;
          };
          thumbnail.src = thumbnailSource(192);
          thumbnail.srcset = [64, 128, 192].map(width => `${thumbnailSource(width)} ${width}w`).join(', ');
          thumbnail.sizes = '64px';
        }
        button.append(thumbnail);
        button.addEventListener('click', () => {
          slides.forEach((item, i) => item.hidden = i !== index);
          [...controls.children].forEach((item, i) => item.setAttribute('aria-pressed', String(i === index)));
        });
        controls.append(button);
      });
      gallery.append(controls);
    });
    scope.querySelectorAll('[data-routine]').forEach(routine => {
      if (routine.dataset.bound) return;
      routine.dataset.bound = 'true';
      const button = routine.querySelector('[data-routine-add]');
      const status = routine.querySelector('[data-routine-status]');
      const rows = [...routine.querySelectorAll('[data-routine-item]')];
      let busy = false, uncertain = false;
      const selected = () => rows.filter(row => row.querySelector('input[type=checkbox]')?.checked);
      const update = () => {
        const total = selected().reduce((sum,row) => sum + Number(row.querySelector('select').selectedOptions[0].dataset.price),0);
        routine.querySelector('[data-routine-total]').textContent = `${selected().length} selected · ${new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:routine.dataset.currency || 'USD'}).format(total / 100)}`;
        button.disabled = busy || uncertain || !selected().length;
      };
      button.hidden = false;
      routine.addEventListener('change', update);
      button.addEventListener('click', async () => {
        if (busy || uncertain || !selected().length) return;
        const chosen = selected();
        const items = chosen.map(row => ({id:Number(row.querySelector('select').value),quantity:1}));
        if (items.some(item => !Number.isSafeInteger(item.id) || item.id <= 0)) return;
        busy = true; status.textContent = 'Adding your selections…';
        const controls = [...routine.querySelectorAll('input,select')];
        controls.forEach(control=>control.disabled=true);button.setAttribute('aria-busy','true');update();
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
          if (!response.ok) throw new Error('Cart outcome requires review');
          chosen.forEach(row=>row.querySelector('input').checked=false);
          status.textContent = 'Added your selected items. Open your bag to review quantities and checkout.';
          document.dispatchEvent(new CustomEvent('routine:added',{detail:{count:items.length}}));
          // Adding and refreshing are separate outcomes: never invite a duplicate add after success.
          try {
            const drawer = await window.SoBotanicalCart?.refreshDrawer();
            if (drawer) window.SoBotanicalTheme?.openDialog(drawer, button);
          } catch {
            status.textContent = 'Added your selected items. The bag preview could not refresh; open your bag to review them.';
          }
        } catch {
          uncertain = true;
          status.textContent = 'We could not confirm every item. Review your bag before adding again; some items may already be there. You can complete your choices from each product page.';
        } finally {
          busy = false; controls.forEach(control=>control.disabled=false);button.removeAttribute('aria-busy');update();
        }
      });
      update();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
